import { render, staticRenderFns } from "./EzSpecialTierModal.vue?vue&type=template&id=5ff5e927&scoped=true&"
import script from "./EzSpecialTierModal.vue?vue&type=script&lang=js&"
export * from "./EzSpecialTierModal.vue?vue&type=script&lang=js&"
import style0 from "./EzSpecialTierModal.vue?vue&type=style&index=0&id=5ff5e927&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5e927",
  null
  
)

export default component.exports